var _rect, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparklesAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_222_2307)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 14.5L25.132 23.2195C24.9852 23.6658 24.7357 24.0713 24.4035 24.4035C24.0713 24.7357 23.6658 24.9852 23.2195 25.132L14.5 28L23.2195 30.868C23.6658 31.0148 24.0713 31.2643 24.4035 31.5965C24.7357 31.9287 24.9852 32.3342 25.132 32.7805L28 41.5L30.868 32.7805C31.0148 32.3342 31.2643 31.9287 31.5965 31.5965C31.9287 31.2643 32.3342 31.0148 32.7805 30.868L41.5 28L32.7805 25.132C32.3342 24.9852 31.9287 24.7357 31.5965 24.4035C31.2643 24.0713 31.0148 23.6658 30.868 23.2195L28 14.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5V20.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 35.5V41.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.5H20.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 38.5H41.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_2307",
    x1: 0,
    y1: 28,
    x2: 56,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC008C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC6767"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesAuth);
export default __webpack_public_path__ + "static/media/sparkles_auth.266be1a1c25f8067775065df366b8825.svg";
export { ForwardRef as ReactComponent };